<template>
  <div v-if="unreadCount > 0" class="global-nav__item-count a-notification-count is-only-mentor">
    {{ unreadCount }}
  </div>
</template>

<script>
import { setFavicon, DEFAULT_FAVICON_PATH, UNREAD_FAVICON_PATH } from './favicon';
import role from 'role'
//import toast from './toast';

export default {
  mixins: [role/*, toast*/],

  props: {
    currentUser: {
      type: Object,
      required: true
    },
    pagePath: { // 通知クリック時に遷移するチャット画面のURL
      type: String,
      required: true
    }
  },
  data() {
    return {
      unreadCount: 0, // 未読メッセージの数
      lastReadCommentId: null, // ★ 最新の既読チャットIDを保持
      pollingInterval: null // ★ ポーリングのタイマーを保持
    };
  },
  mounted() {
    // ページロード時に未読件数を一度取得し、ポーリングを開始
    this.fetchLatestChatId(); // true で初回取得
    this.pollingInterval = setInterval(() => this.fetchUnreadCount(), 60 * 1000); // 60秒ごとに実行

    this.requestNotificationPermission();
    this.updateFavicon(); // 初期表示時のファビコン設定
  },
  beforeUnmount() {
    // コンポーネント破棄時にポーリングを停止
    if (this.pollingInterval) clearInterval(this.pollingInterval);
  },
  methods: {
    /**
     * 初回ロード時に最新のチャットIDを取得します。
     * このメソッドは、ポーリング開始前の初期化に使用されます。
     */
    async fetchLatestChatId() {
      const apiUrl = '/api/mentor/chats/latest_id'; // 最新IDを取得するAPI

      try {
        const response = await fetch(apiUrl, {
          method: 'GET',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        });

        if (!response.ok) {
          throw new Error(`API Error: ${response.status} ${response.statusText}`);
        }

        const data = await response.json();
        // 初回ロード時は、最新のチャットIDをセット
        this.lastReadCommentId = data.id;
      } catch (error) {
        console.error('最新チャットIDの取得に失敗しました:', error);
      }
    },
    /**
     * 60秒ごとにポーリングし、新規メッセージの件数を取得して更新します。
     * このメソッドは、ポーリングの度に呼び出されます。
     */
    async fetchUnreadCount() {
      // after_id が null の場合はポーリングしない
      if (!this.lastReadCommentId) return;

      const [startHour, startMinute] = [9, 0];
      const [endHour, endMinute] = [19, 0];
      const now = new Date();

      // 開始と終了の日時オブジェクトを生成
      // 現在の日付を使い、指定された時分を組み合わせて比較
      const startTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), startHour, startMinute);
      const endTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), endHour, endMinute);

      // 終了時間が開始時間より前の場合は、翌日として扱う
      if (endTime < startTime) {
        endTime.setDate(endTime.getDate() + 1);
      }

      // 現在時刻が有効期間内にあるかどうかを判定
      const isNowEnabled = (now >= startTime && now < endTime);

      if (!isNowEnabled) return;

      const apiUrl = `/api/mentor/chats/unread_count?after_id=${this.lastReadCommentId}`;

      try {
        const response = await fetch(apiUrl, {
          method: 'GET',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        });

        if (!response.ok) {
          throw new Error(`API Error: ${response.status} ${response.statusText}`);
        }

        const data = await response.json();

        if (data.count > 0) {
          // 未読件数があればカウントを更新
          this.unreadCount = data.count;
          this.updateFavicon();
          this.displayBrowserNotification(data.count);
        }
      } catch (error) {
        console.error('未読件数の取得に失敗しました:', error);
      }
    },
    /**
     * 未読カウントをリセットし、チャット画面へ遷移します。
     */
    resetUnreadCount() {
      // チャット画面に遷移する際にこのメソッドが呼ばれることを想定
      this.unreadCount = 0;
      this.updateFavicon(); // ファビコンをデフォルトに戻す
    },

    /**
     * ブラウザ通知を表示します。
     * @param {number} count - 新着メッセージの件数
     */
    displayBrowserNotification(count) {
      if (Notification.permission === "granted") {
        const options = {
          body: `講師チャットに${count}件の新しいメッセージがあります。`,
          icon: '/favicon.ico',
          tag: 'new-mentor-chat-message',
          renotify: true
        };
        const notification = new Notification(`新着メッセージがあります`, options);

        notification.onclick = (event) => {
          event.preventDefault();
          window.focus();
          window.location.href = this.pagePath;
          //this.resetUnreadCount(); // 未読カウントをリセット
          notification.close();
        };
      }
    },

    /**
     * ブラウザ通知（Web Notification API）の許可をユーザーに求めます。
     */
    requestNotificationPermission() {
      if (!("Notification" in window)) {
        console.warn("このブラウザはデスクトップ通知をサポートしていません。");
        return;
      }
      if (Notification.permission === "default") {
        Notification.requestPermission().then(permission => {
          if (permission === "granted") {
            console.log("通知の許可が得られました。");
          } else {
            console.warn("通知の許可が拒否されました。");
          }
        });
      }
    },

    /**
     * 未読カウントに基づいてファビコンを更新します。
     */
    updateFavicon() {
      if (this.unreadCount > 0) {
        setFavicon(UNREAD_FAVICON_PATH);
      } else {
        setFavicon(DEFAULT_FAVICON_PATH);
      }
    }
  }
};
</script>